import { observer } from 'mobx-react';
import * as React from 'react';
import { ParticipantResource } from '../../../../ParticipantsStore/Types';
import { currentUserStore } from '../../../../CurrentUserStore';
import { findLink } from '../../../../LinkyLinky';
import { GroupResource } from '../../../../GroupsStore/Types';
import { emptyFragment } from '../../../../EmptyFragment';

interface Props {
  resource: ParticipantResource | GroupResource;
}

const OrganizationColumnData: React.FC<Props> = ({ resource }) =>
  findLink('options', currentUserStore.links)
    .map(() => (
      <td className="whitespace-nowrap px-3 py-4 text-sm text-gray-500">
        {resource.payload.organization}
      </td>
    ))
    .getOrElse(emptyFragment);

export default observer(OrganizationColumnData);
